export default __webpack_public_path__ + "static/media/microfono.4a5f1e1f.png";